




















import { Vue, Component } from 'vue-property-decorator';
import LifecycleModule from '@/store/modules/lifecycle';
import UserModule from '@/store/modules/user';
import { PartnerOnboardingStatusEnum } from '@compassdigital/foodworks.ts.sdk';

@Component({
  components: { },
})
export default class Loading extends Vue {
  async load() {
    try {
      await LifecycleModule.init();
      // const requiresOnboarding = UserModule.currentPartner?.onboarding?.status
      // === PartnerOnboardingStatusEnum.AwaitPartner;
      // if (requiresOnboarding) {
      //   return this.$router.replace('/application/detail_forms');
      // }
      if (this.$router.app.$route.query && this.$router.app.$route.query.redirect) {
        return this.$router.replace(this.$router.app.$route.query.redirect as string);
      }
      return this.$router.replace('/home');
    } catch (err) {
      return this.$router.replace({
        name: 'login',
        query: this.$route.query,
      });
    }
  }

  mounted() {
    this.load();
  }
}
